import { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { EmailIcon, PlusIcon, RupeeIcon, SparkleIcon, UserIcon, DatabaseIcon } from "../../../shared/icons/Icons";
import { getApi } from "../../../shared/services/apiHelper";

import './Settings.scss';
import '../projects/ProjectAdd.scss';

export default function Settings (props) {
    const [defaultRates, setDefaultRates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(null);
    const [activeTable, setActiveTable] = useState('default');

    const [labourRates, setLabourRates] = useState([]);
    const [loadingLabourRates, setLoadingLabourRates] = useState(false);


    useEffect(() => {
        fetchDefaultRates();
        fetchUserProfile();
        fetchMaterialRates();
        fetchLabourRates();
    }, []);

    const fetchDefaultRates = async () => {
        try {
            setLoading(true);
            const response = await getApi('/api/rates/default');
            const rates = response?.data?.rates;
            if (rates) {
                const ratesArray = Object.entries(rates).map(([label, value]) => ({
                    label,
                    rate: value.rate,
                    unit: value.unit,
                }));
                setDefaultRates(ratesArray);
            }
        } catch (error) {
            console.error("Failed to fetch default rates:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchLabourRates = async () => {
        try {
            setLoadingLabourRates(true);
            const response = await getApi('/api/labour-rates/default');
            const rates = response?.data?.rates;
            if (rates) {
                const ratesArray = Object.entries(rates).map(([label, value]) => ({
                    label,
                    rate: value.rate,
                    unit: value.unit,
                }));
                setLabourRates(ratesArray);
            }
        } catch (error) {
            console.error("Failed to fetch labour rates:", error);
        } finally {
            setLoadingLabourRates(false);
        }
    };

    const [materialRates, setMaterialRates] = useState([]);
    const [loadingMaterialRates, setLoadingMaterialRates] = useState(false);

    const fetchMaterialRates = async () => {
        try {
            setLoadingMaterialRates(true);
            const response = await getApi('/api/material-rates/default');
            const rates = response?.data?.rates;
            if (rates) {
                const ratesArray = Object.entries(rates).map(([label, value]) => ({
                    label,
                    rate: value.rate,
                    unit: value.unit,
                }));
                setMaterialRates(ratesArray);
            }
        } catch (error) {
            console.error("Failed to fetch material rates:", error);
        } finally {
            setLoadingMaterialRates(false);
        }
    };

    const fetchUserProfile = async () => {
        try {
            const response = await getApi('/api/users/me');
            const userData = response?.data;
            if (userData) {
                setUser(userData);
            }
        } catch (error) {
            console.error("Failed to fetch user profile:", error);
        }
    };
    return(
        <>
        <style>
         { 
         `@media (max-width: 991px) {
    .content-box {
        padding-left: 28px !important;
        padding-right: 0px !important;
        overflow-x: hidden;
    }` 
    }


        </style>
        <div className="settings-view main-content animate-fade-in">
            <div className="d-flex flex-column activity-card w-70 gap-3">
                <div className="d-flex gap-3">
                    <div className={`metric-icon summary-icon-purple`}>
                        <UserIcon />
                    </div>
                    <div>
                        <h3 className="content-label">Account Settings</h3>
                        <p className="content-sub-label">Manage your account preferences</p>
                    </div>
                </div>
                <div className="d-flex gap-3 account-settings-row">
                    <div className="d-flex metric-card-view gap-3 w-100">
                        <div className="metric-icon summary-icon-purple">
                            <UserIcon />
                        </div>
                        <div>
                            <div className="content-label">Name</div>
                            <p className="content-sub-label">{user?.name || '---'}</p>
                        </div>
                    </div>
                    <div className="d-flex metric-card-view gap-3 w-100">
                        <div className="metric-icon summary-icon-purple">
                            <EmailIcon />
                        </div>
                        <div>
                            <div className="content-label">Email</div>
                            <p className="content-sub-label">{user?.email || '---'}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="d-flex flex-column activity-card w-70 gap-3">
                <div className="d-flex gap-3">
                    <div className={`metric-icon ${activeTable === 'default' ? 'summary-icon-green' : activeTable === 'material' ? 'summary-icon-blue' : 'summary-icon-purple'}`}>
                        {activeTable === 'default' ? <SparkleIcon /> : <DatabaseIcon />}
                    </div>
                    <div>
                        <h3 className="content-label">
                            {activeTable === 'default' ? 'Default Construction Rates' : 
                             activeTable === 'material' ? 'Material Rates' : 'Labour Rates'}
                        </h3>
                        <p className="content-sub-label">
                            {activeTable === 'default' ? 'Reference rates used when no custom rate is specified' : 
                             activeTable === 'material' ? 'Reference material unit rates' : 'Reference labour unit rates'}
                        </p>
                    </div>
                </div>

                <div className="d-flex gap-3 cost-toggle-row">
                    <Button
                        className={`btn-cost-toggle ${activeTable === 'default' ? 'active' : ''}`}
                        onClick={() => setActiveTable('default')}
                    >
                        Default Cost
                    </Button>
                    <Button
                        className={`btn-cost-toggle ${activeTable === 'material' ? 'active' : ''}`}
                        onClick={() => setActiveTable('material')}
                    >
                        Material Cost
                    </Button>
                    <Button
                        className={`btn-cost-toggle ${activeTable === 'labour' ? 'active' : ''}`}
                        onClick={() => setActiveTable('labour')}
                    >
                        Labour Cost
                    </Button>
                </div>

                {activeTable === 'default' && (
                    <div className="estimate-table-card">
                        <table className="estimate-table">
                            <thead>
                            <tr>
                                <th>Item</th>
                                <th>Rate</th>
                                <th>Unit</th>
                            </tr>
                            </thead>

                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td className="item-name" colSpan={3}>Loading rates...</td>
                                    </tr>
                                ) : defaultRates.length === 0 ? (
                                    <tr>
                                        <td className="item-name" colSpan={3}>No rates available</td>
                                    </tr>
                                ) : (
                                    defaultRates.map((item, index) => (
                                        <tr key={item.label}>
                                            <td className="item-name fs-5">{item.label}</td>
                                            <td className="fs-5">{item.rate}</td>
                                            <td className="fs-5">{item.unit}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                )}

                {activeTable === 'material' && (
                    <div className="estimate-table-card">
                        <table className="estimate-table">
                            <thead>
                            <tr>
                                <th>Item</th>
                                <th>Rate</th>
                                <th>Unit</th>
                            </tr>
                            </thead>

                            <tbody>
                                {loadingMaterialRates ? (
                                    <tr>
                                        <td className="item-name" colSpan={3}>Loading material rates...</td>
                                    </tr>
                                ) : materialRates.length === 0 ? (
                                    <tr>
                                        <td className="item-name" colSpan={3}>No material rates available</td>
                                    </tr>
                                ) : (
                                    materialRates.map((item, index) => (
                                        <tr key={item.label}>
                                            <td className="item-name fs-5">{item.label}</td>
                                            <td className="fs-5">{item.rate}</td>
                                            <td className="fs-5">{item.unit}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                )}

                {activeTable === 'labour' && (
                    <div className="estimate-table-card">
                        <table className="estimate-table">
                            <thead>
                            <tr>
                                <th>Item</th>
                                <th>Rate</th>
                                <th>Unit</th>
                            </tr>
                            </thead>

                            <tbody>
                                {loadingLabourRates ? (
                                    <tr>
                                        <td className="item-name" colSpan={3}>Loading labour rates...</td>
                                    </tr>
                                ) : labourRates.length === 0 ? (
                                    <tr>
                                        <td className="item-name" colSpan={3}>No labour rates available</td>
                                    </tr>
                                ) : (
                                    labourRates.map((item, index) => (
                                        <tr key={item.label}>
                                            <td className="item-name fs-5">{item.label}</td>
                                            <td className="fs-5">{item.rate}</td>
                                            <td className="fs-5">{item.unit}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            <div className="d-flex flex-column activity-card w-70 gap-3">
                <div className="d-flex justify-content-between gap-3 custom-rates-header">
                    <div className="d-flex gap-3">
                        <div className={`metric-icon summary-icon-orange`}>
                            <RupeeIcon />
                        </div>
                        <div>
                            <h3 className="content-label">Custom Construction Rates</h3>
                            <p className="content-sub-label">Override default rates with your pricing</p>
                        </div>
                    </div>
                    <div>
                        <Button variant="primary"><PlusIcon /> Add Rates</Button>
                    </div>
                </div>
                <div className="d-flex flex-column align-items-center gap-3">
                    <RupeeIcon />
                    <p>No custom rates configured</p>
                    <p>Click "Add Rate" to override default construction rates</p>
                </div>
            </div>

        </div>
        </>

    )
}